"use client";

import { memo } from "react";
import { HeroDark } from "@/components/screen/global-components/hero";

const PrivacyHero = ({
}: React.ComponentProps<"section">) => {
  return <HeroDark title="Languex privacy policy" description="Your privacy matters. Learn how we protect your data with care, transparency, and security." />;
};

export default memo(PrivacyHero);
